import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * infrastructure module ServiceStores.
 * Declares the services its ViewStores consume (migrated off the removed
 * createRestApi). Each entry: { name: <feathers service path>, options }.
 */
export const infrastructureStores: ServiceStoreConfig[] = [
  // Docker control-plane CRUD/list services (standard `id` PK).
  { name: "docker-hosts", options: { idField: "id", enableStorage: false } },
  // replaceOnFind: this find is a LIVE DISCOVERY SNAPSHOT of the whole fleet,
  // not a table page — each result is the complete truth-set. The default
  // merge-only cache could never evict a row deleted server-side, so the
  // Remove action (and the 7-day missing auto-purge) soft-deleted rows that
  // then stayed on the grid until a full page reload — "I removed it and
  // nothing happened" (2026-08-21). With replaceOnFind the post-action re-pull
  // drops them. (Client 360's Instances tab reads its find RESULT directly,
  // not this cache, so its clientId-filtered find replacing the set is fine —
  // the grid re-finds the full fleet on every route enter.)
  { name: "client-instances", options: { idField: "id", enableStorage: false, replaceOnFind: true } },
  { name: "portainer-connections", options: { idField: "id", enableStorage: false } },
  // Create-only mutating action seam (one action per POST) + its read-only
  // append-only audit history. Both carry a standard `id`.
  //
  // enableOffline OFF is REQUIRED for the action seam: the API registers it with
  // `methods: ['create', 'patch']` only, so the offline wrapper's blanket
  // sync-on-reconnect (a bare find()) can never succeed — it threw
  // "Method 'find' not allowed on service 'instance-actions'" on every socket
  // connect and dropped the store into offline fallback. Offline is wrong here
  // on its own terms too: start/stop/restart/kill/deploy/rollback must never be
  // queued locally and replayed against a container minutes or hours later.
  // Read history comes from instance-action-audit, which IS find-capable.
  {
    name: "instance-actions",
    options: { idField: "id", enableStorage: false, enableOffline: false },
  },
  { name: "instance-action-audit", options: { idField: "id", enableStorage: false } },
  // Derived read-only drift rollup — one row per hosted client instance, keyed
  // by the `client_instances` UUID (`instanceId`), no separate `id`.
  { name: "instance-drift", options: { idField: "instanceId", enableStorage: false } },
  // Azure Container Registry: writable connection registry (admin-gated) + the
  // read-through catalog services that feed the deploy image-picker. The catalog
  // services are find-only and keyed by synthetic fields, so storage is off.
  { name: "registry-connections", options: { idField: "id", enableStorage: false } },
  { name: "registry-repositories", options: { idField: "name", enableStorage: false } },
  // enableOffline OFF is REQUIRED, same reason as the devops proxies: this
  // service's find() throws BadRequest without a `repository` query param, so
  // the offline wrapper's blanket sync-on-reconnect (a bare find()) can never
  // succeed — it just logged "repository query parameter is required" on every
  // socket connect and dropped the store into offline fallback. It is the only
  // infrastructure service that rejects a bare find().
  {
    name: "registry-tags",
    options: { idField: "name", enableStorage: false, enableOffline: false },
  },
  // NOT here, deliberately: `instance-connections`, `instance-users` and
  // `instance-remote-audit` (Client 360 → Users). Their create responses carry
  // one-time secrets (a temporary password, a new key's config entry) and a
  // ServiceStore would keep them in its entity cache for the session, so
  // InstanceUsersStore calls them through the raw Feathers client instead.
];
